import { transformTwilioMessageDtoToModel } from "../TwilioMessage";
import { TwilioConversationDto } from "./TwilioConversationDto";
import { TwilioConversationModel } from "./TwilioConversationModel";

export const transformTwilioConversationDtoToModel = (
  dto: TwilioConversationDto
): TwilioConversationModel => ({
  ...dto,
  ...transformTwilioMessageDtoToModel(dto),
});
